module.exports = __webpack_public_path__ + "img/1489875107.81a8eb8e.jpg";